<template>
  <div class="topic-card">
    <div
      class="topic-header"
      :title="props.topic.name"
    >
      <p @click="chooseTheme(props.topic)">
        {{ props.topic.name }}
      </p>
    </div>
    <div
      v-if="cards?.length"
      class="box"
    >
      <div style="height: 1px; background: #e7e7e7" />
      <PulseNewsView
        v-if="cards?.length > 0"
        :news-item="cards[0]"
      />
      <div style="height: 1px; background: #e7e7e7" />
      <PulseNewsView
        v-if="cards?.length > 1"
        :news-item="cards[1]"
        style="
          border-top: 1px solid white;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        "
      />
    </div>
    <div
      v-else
      class="box-else"
    >
      <div class="container">
        <span class="box-else__title">
          {{ t('country_pulse_topic_card.topic_empty_title') }}
        </span>
        <span class="box-else__text">
          {{ t('country_pulse_topic_card.topic_empty_text') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import PulseNewsView from "@/components/PulsePage/PulseNewsView.vue";
import { t } from "@/controllerLK/AvalLocalization";
import { computed, defineProps } from "vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { useBlockStore } from "@/store/NewsFeed/blocks";

const newsFeedStore = useNewsFeedStore();
const rubricStore = useRubricsStore();
const blockStore = useBlockStore();

const props = defineProps({
  topic: {
    type: Object,
    required: true
  }
});

const cards = computed(() => {
  return [...props.topic.cards]?.sort((a, b) => b.date - a.date); // Сортировка новостей внутри блока (1231)
});


// Выбор темы и переход на страницу новостей.
const chooseTheme = async (theme) => {
  blockStore.chosenThemes = [theme.id];
  rubricStore.chosenRubrics = blockStore.allRubricsInThemes();

  // Задача 2117 - сброс фильтров (обхектов) при клике на тему в пульсе.
  newsFeedStore.filterObject.list = [];
  newsFeedStore.filterObject.listID.persons.length = 0;
  newsFeedStore.filterObject.listID.locations.length = 0;
  newsFeedStore.filterObject.listID.organisations.length = 0;
  newsFeedStore.initialFacetObjects.persons.length = 0;
  newsFeedStore.initialFacetObjects.locations.length = 0;
  newsFeedStore.initialFacetObjects.organisations.length = 0;

  await newsFeedStore.clearNewsFeed();
  await window.routerLK.push("/");
  await newsFeedStore.getNews();
};

</script>

<style lang="scss" scoped>

.topic-card {
  border-radius: 10px;
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;

  .topic-header {

    text-align: start;
    min-height: 62px;
    padding: 20px;
    overflow-x: hidden;
    p {
      font-size: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        color: #1F9AFF;
      }
    }
  }

  .box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .box-else {
    padding: 10px 20px 20px 20px;
    height: 100%;

    .container {
      width: 100%;
      height: 100%;
      background: #F7F8FD;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;


      .box-else__title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        padding: 6px 0;
      }

      .box-else__text {
        color: #373D3F;
        font-size: 14px;
        line-height: 20px;
        padding: 20px 0;
        max-width: 208px;
      }
    }
  }
}
</style>
